@if (showLoader) {
  <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
}
@if (!showLoader) {
  <app-documents #documents [weavyData]="weavyData" [downloadAdditionalDocsInput]="downloadAdditionalDocs" [docType]="'policy'"></app-documents>
}